import { useAppTheme } from "../../useAppTheme";
import useBreakpoints from "../../useBreakpoints";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";
import { LeaderboardPodiumSkeleton } from "./LeaderboardPodiumSkeleton";
import { LeaderboardRankRowSkeleton } from "./LeaderboardRankRowSkeleton";
import { getSkeletonRowCount } from "./helpers";

type Props = {
	numUsersToDisplay?: number;
	showUsersPodium?: boolean;
	showActionCard?: boolean;
};

export const LeaderboardSkeleton = ({
	numUsersToDisplay = 10,
	showUsersPodium = true,
	showActionCard = true,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const { xsDown } = useBreakpoints();
	const rowCount = getSkeletonRowCount({ numUsersToDisplay, showUsersPodium });

	const actionButton = <Skeleton width={180} height={40} />;

	return (
		<Box gap={isMobile ? 0 : 8} paddingBottom={16}>
			<Box gap={isMobile ? 0 : 1}>
				{showUsersPodium && (
					<FlatCard
						style={
							showActionCard
								? {
										borderBottomLeftRadius: 0,
										borderBottomRightRadius: 0,
									}
								: undefined
						}
					>
						<Box padding={16} gap={8}>
							<Skeleton width={96} height={24} />
							<LeaderboardPodiumSkeleton />
						</Box>
					</FlatCard>
				)}

				{showActionCard && (
					<FlatCard
						style={
							showUsersPodium
								? {
										borderTopLeftRadius: 0,
										borderTopRightRadius: 0,
									}
								: undefined
						}
					>
						<Box padding={16} gap={16}>
							<Box flexDirection="row" alignItems="center" gap={12}>
								<Skeleton size={48} />
								<Box flex={1} gap={4}>
									<Skeleton width="45%" height={16} />
									<Skeleton width="70%" height={12} />
								</Box>
								{!xsDown && actionButton}
							</Box>
							{xsDown && actionButton}
						</Box>
					</FlatCard>
				)}
			</Box>

			<FlatCard>
				<Box
					flexDirection="row"
					alignItems="center"
					gap={12}
					padding={16}
					borderBottomWidth={1}
					borderBottomColor={theme.colors.surfaceVariant}
				>
					<Skeleton size={40} variant="circle" />
					<Skeleton width={140} height={14} />
				</Box>
				{Array.from({ length: rowCount }).map((_, index) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
					<LeaderboardRankRowSkeleton key={index} />
				))}
			</FlatCard>
		</Box>
	);
};
